export const KONE_LIFT_DIMENSIONS = {
  "8 Persons / 630 kg": [
    {
      car: { width_mm: 1100, depth_mm: 1400 },
      shaft: { width_mm: 1650, depth_mm: 1810 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
    {
      car: { width_mm: 1100, depth_mm: 1400 },
      shaft: { width_mm: 1745, depth_mm: 2105 },
      supported_speeds: [2.0],
    },
    {
      car: { width_mm: 1100, depth_mm: 1400 },
      shaft: { width_mm: 1680, depth_mm: 1960 },
      supported_speeds: [2.5],
    },
    {
      car: { width_mm: 1100, depth_mm: 1650 },
      shaft: { width_mm: 1650, depth_mm: 2040 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
    {
      car: { width_mm: 1350, depth_mm: 1400 },
      shaft: { width_mm: 1690, depth_mm: 2215 },
      supported_speeds: [2.0],
    },
    {
      car: { width_mm: 1350, depth_mm: 1400 },
      shaft: { width_mm: 1680, depth_mm: 2205 },
      supported_speeds: [2.5],
    },
  ],
  "10 Persons / 800 kg": [
    {
      car: { width_mm: 1100, depth_mm: 1650 },
      shaft: { width_mm: 1900, depth_mm: 1790 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
    {
      car: { width_mm: 1100, depth_mm: 1650 },
      shaft: { width_mm: 1995, depth_mm: 2085 },
      supported_speeds: [2.0],
    },
    {
      car: { width_mm: 1350, depth_mm: 1400 },
      shaft: { width_mm: 2030, depth_mm: 2085 },
      supported_speeds: [2.5],
    },
  ],
  "13 Persons / 1000 kg": [
    {
      car: { width_mm: 1100, depth_mm: 2100 },
      shaft: { width_mm: 1650, depth_mm: 2480 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
    {
      car: { width_mm: 1100, depth_mm: 2100 },
      shaft: { width_mm: 1690, depth_mm: 2515 },
      supported_speeds: [2.0],
    },
    {
      car: { width_mm: 1100, depth_mm: 2100 },
      shaft: { width_mm: 1680, depth_mm: 2505 },
      supported_speeds: [2.5],
    },
    {
      car: { width_mm: 1400, depth_mm: 1600 },
      shaft: { width_mm: 1800, depth_mm: 2480 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
    {
      car: { width_mm: 1400, depth_mm: 1600 },
      shaft: { width_mm: 1810, depth_mm: 2505 },
      supported_speeds: [2.0],
    },
    {
      car: { width_mm: 1400, depth_mm: 1600 },
      shaft: { width_mm: 1740, depth_mm: 1990 },
      supported_speeds: [2.5],
    },
    {
      car: { width_mm: 1400, depth_mm: 1600 },
      shaft: { width_mm: 1960, depth_mm: 2075 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
    {
      car: { width_mm: 1400, depth_mm: 1600 },
      shaft: { width_mm: 1940, depth_mm: 1990 },
      supported_speeds: [2.0],
    },
    {
      car: { width_mm: 1400, depth_mm: 1600 },
      shaft: { width_mm: 1960, depth_mm: 2075 },
      supported_speeds: [2.5],
    },
  ],
  "17 Persons / 1275 kg": [
    {
      car: { width_mm: 1200, depth_mm: 2300 },
      shaft: { width_mm: 1850, depth_mm: 2710 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
    {
      car: { width_mm: 1200, depth_mm: 2300 },
      shaft: { width_mm: 1905, depth_mm: 2805 },
      supported_speeds: [2.0],
    },
    {
      car: { width_mm: 1200, depth_mm: 2300 },
      shaft: { width_mm: 1915, depth_mm: 2805 },
      supported_speeds: [2.5],
    },
    {
      car: { width_mm: 1200, depth_mm: 2300 },
      shaft: { width_mm: 1985, depth_mm: 2795 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
  ],
  "21 Persons / 1600 kg": [
    {
      car: { width_mm: 1400, depth_mm: 2400 },
      shaft: { width_mm: 1995, depth_mm: 2785 },
      supported_speeds: [1.0, 1.6, 1.75],
    },
    {
      car: { width_mm: 1400, depth_mm: 2400 },
      shaft: { width_mm: 2285, depth_mm: 2905 },
      supported_speeds: [2.0, 2.5],
    },
  ],
  "26 Persons / 2000 kg": [
    {
      car: { width_mm: 1500, depth_mm: 2700 },
      shaft: { width_mm: 2300, depth_mm: 3210 },
      supported_speeds: [1.0, 1.6, 1.75, 2.0, 2.5],
    },
  ],
};

export function findKoneLiftOption(sizeKey, targetSpeed) {
  const options = KONE_LIFT_DIMENSIONS[sizeKey];
  if (!Array.isArray(options) || options.length === 0) {
    return null;
  }

  const numericSpeed = Number(targetSpeed);

  const matching = Number.isFinite(numericSpeed)
    ? options.filter((option) => {
        const speeds = option.supported_speeds;
        if (!Array.isArray(speeds) || speeds.length === 0) {
          return true;
        }
        return speeds.some((s) => {
          const numeric = Number(s);
          return Number.isFinite(numeric) && numeric + 1e-6 >= numericSpeed;
        });
      })
    : options;

  const candidates = matching.length > 0 ? matching : options;

  return [...candidates].sort((a, b) => {
    const areaA = (a.shaft.width_mm * a.shaft.depth_mm) / 1_000_000;
    const areaB = (b.shaft.width_mm * b.shaft.depth_mm) / 1_000_000;
    return areaA - areaB;
  })[0];
}

export function toSquareMetres(widthMm, depthMm) {
  if (!Number.isFinite(widthMm) || !Number.isFinite(depthMm)) {
    return null;
  }
  return (widthMm * depthMm) / 1_000_000;
}
